'use strict'

paginationFooterTemplate = require '../../footer.html.mustache'
paginationFooterPresenter = require '../../common/presenters/footer'
domConfig = require '../../../page/frontend/helpers/dom_config'

module.exports = class PaginationFooterView extends Backbone.View
  events:
    'click .pagination a': 'paginationClickHandler'

  initialize: ->
    @presentedHash = null

  updatePresentedHash: (dealSearch) ->
    page = dealSearch.page
    {number, totalPages, nextPageSize, totalDealCount, startingIndex, endingIndex} = page

    paginationFooter = _.extend {}, paginationFooterPresenter.toHash {
      requestURL: window.location.pathname
      query: Groupon.Utils.unparam()
      currentPageNumber: number
      totalPages
      nextPageSize: nextPageSize
      totalDealCount: totalDealCount
      startingIndex: startingIndex
      endingIndex: endingIndex
      limitResults: domConfig.get().enabledFeatures.limitPaginationResults
    }, undefined, {I18n}

    @presentedHash = {paginationFooter}

    this

  render: (opts = {}) ->
    if opts.presentedHash then @presentedHash = opts.presentedHash

    @$el.html @toHtml()

  toHtml: ->
    paginationFooterTemplate.render @presentedHash

  paginationClickHandler: (event) =>
    event.preventDefault()
    @trigger 'click:paginationLink', event
